module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon_kids-5992f0ad51a770ac4071ea1f07a342bf.svg";